import React, { ReactNode, useCallback } from "react";

import cn from "classnames";

import { CardCollapse, CollapsePanel } from "@mapmycustomers/ui";

import styles from "./CollapseCard.module.scss";

const PANEL_KEY = "collapse-card";

export interface CollapseCardProps {
  children: ReactNode;
  className?: string;
  // Off by default, as antd has it: a card whose children are cheap keeps them mounted so they
  // reopen with their state. Set it where the children are not cheap to hold twice.
  destroyOnClose?: boolean;
  header: ReactNode;
  isOpenByDefault?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
}

const CollapseCard = ({
  children,
  className,
  destroyOnClose,
  header,
  isOpenByDefault,
  onClose,
  onOpen,
}: CollapseCardProps) => {
  const handleChange = useCallback(
    (key: string | string[]) => {
      if (Array.isArray(key) && key.length) {
        onOpen?.();
      } else {
        onClose?.();
      }
    },
    [onClose, onOpen]
  );
  return (
    <CardCollapse
      className={cn(styles.collapse, className)}
      defaultActiveKey={isOpenByDefault ? PANEL_KEY : undefined}
      destroyInactivePanel={destroyOnClose}
      onChange={handleChange}
      size="small"
    >
      <CollapsePanel header={header} key={PANEL_KEY}>
        <div>{children}</div>
      </CollapsePanel>
    </CardCollapse>
  );
};

export default CollapseCard;
